import React from "react";
import { connect } from "react-redux";
import { ReduxProps } from "../../../models/ReduxProps";
import IStore from "../../../models/IStore";
import ConfigurationAction from "stores/configuration/ConfigurationAction";

interface IProps {}
interface IState {}
interface IStateToProps {
    readonly analyticsUID: string;
    readonly campiBoxPreventivo: boolean;
}

const mapStateToProps = (state: IStore, ownProps: IProps): IStateToProps => ({
    analyticsUID: state.configuration.getconfiguration.analyticsUID ?? "",
    campiBoxPreventivo: state.configuration.getconfiguration.campiBoxPreventivo ?? false,
});

class Configuration extends React.Component<IProps & IStateToProps & ReduxProps<any>, IState> {
    public componentDidMount(): void {
        this.props.dispatch(ConfigurationAction.getConfigurazione());
    }

    public render(): JSX.Element | null {
        return null;
    }
}

export { Configuration as Unconnected };
export default connect(mapStateToProps)(Configuration);
